import { appIcon } from '@/const/underwriting'
/**
 * This file is use for breadcrumb generation (with proper hierarchy) and title lookup. Also used for Menu searching.
 *
 * name: must be unique, lower-case, no-space (primary-key and must be same as route name) - try not to change it for no reason
 * text: Displays on screen
 * icon: Custom icon for menu
 * desc: Description of application
 * children: hierarchy of menu
 * hidden: true if it should be hidden from menu display (also not searchable - use for breadcrumb auto generation)
 * searchable: use only if hidden is true (to allow search even if it is hidden)
 * route: true if menu should route to a page
 * access: access control. Look at router/index.js
 */
export const Menu = [
  {
    name: 'dashboard',
    text: 'Dashboard',
    route: true,
    children: [
      // {
      //   name: 'coreSystem',
      //   text: 'Core System',
      //   children: [
      //     {
      //       name: 'policyAdmin',
      //       text: 'Policy Administration',
      //       children: [
      //         {
      //           name: 'managePolicies',
      //           text: 'Manage Policies',
      //           children: [
      //             { name: 'policy', text: 'Create Policy', route: true }
      //           ]
      //         }
      //       ]
      //     }
      //   ]
      // },
      {
        name: 'agency',
        text: 'Agency',
        children: [
          {
            name: 'quotation',
            text: 'Quotation',
            icon: 'mdi-file-document',
            route: true,
            children: [
              { name: 'motorQuote', text: 'Motor Quote', route: true, hidden: true },
              { name: 'motorQuoteDriver', text: 'Motor Quote', route: true, hidden: true },
              { name: 'motorQuoteVehicle', text: 'Motor Quote', route: true, hidden: true },
              { name: 'motorQuoteStatistics', text: 'Motor Quote', route: true, hidden: true },
              { name: 'motorQuotePremium', text: 'Motor Quote', route: true, hidden: true },
              { name: 'motorQuoteRef', text: 'Motor Quote Pending Approval', route: true, hidden: true },
              { name: 'motorQuoteRefStats', text: 'Motor Quote Pending Approval', route: true, hidden: true },
              { name: 'motorQuoteRefPremium', text: 'Motor Quote Pending Approval', route: true, hidden: true },
              { name: 'motorQuoteAccept', text: 'Motor Quote Approved', route: true, hidden: true },
              { name: 'motorProposal', text: 'Motor Proposal', route: true, hidden: true },
              { name: 'motorProposalDriver', text: 'Motor Proposal', route: true, hidden: true },
              { name: 'motorProposalVehicle', text: 'Motor Proposal', route: true, hidden: true },
              { name: 'motorProposalPremium', text: 'Motor Proposal', route: true, hidden: true },
              { name: 'motorProposalPayment', text: 'Motor Proposal', route: true, hidden: true },
              { name: 'motorProposalRef', text: 'Motor Proposal Pending Approval', route: true, hidden: true },
              { name: 'cargoQuote', text: 'Cargo Quote', route: true, hidden: true },
              { name: 'cargoQuoteShipment', text: 'Cargo Quote', route: true, hidden: true },
              { name: 'cargoQuoteClause', text: 'Cargo Quote', route: true, hidden: true },
              { name: 'cargoQuoteInsured', text: 'Cargo Quote', route: true, hidden: true },
              { name: 'cargoQuotePremium', text: 'Cargo Quote', route: true, hidden: true },
              { name: 'cargoQuoteRef', text: 'Cargo Quote Pending Approval', route: true, hidden: true },
              { name: 'cargoQuoteRefPremium', text: 'Cargo Quote Pending Approval', route: true, hidden: true },
              { name: 'cargoQuoteAccept', text: 'Cargo Quote Approved', route: true, hidden: true },
              { name: 'fireQuote', text: 'Fire Quote', route: true, hidden: true },
              { name: 'fireQuotePlans', text: 'Fire Quote', route: true, hidden: true },
              { name: 'fireQuoteRisk', text: 'Fire Quote', route: true, hidden: true },
              { name: 'fireQuotePremium', text: 'Fire Quote', route: true, hidden: true },
              { name: 'fireQuotePayment', text: 'Fire Quote', route: true, hidden: true },
              { name: 'maidQuote', text: 'Maid Quote', route: true, hidden: true },
              { name: 'maidQuotePlans', text: 'Maid Quote', route: true, hidden: true },
              { name: 'maidQuoteRisk', text: 'Maid Quote', route: true, hidden: true },
              { name: 'maidQuotePremium', text: 'Maid Quote', route: true, hidden: true },
              { name: 'maidQuotePayment', text: 'Maid Quote', route: true, hidden: true },
              { name: 'travelQuote', text: 'Travel Quote', route: true, hidden: true },
              { name: 'travelQuotePlans', text: 'Travel Quote', route: true, hidden: true },
              { name: 'travelQuoteApplicant', text: 'Travel Quote', route: true, hidden: true },
              { name: 'travelQuoteInsured', text: 'Travel Quote', route: true, hidden: true },
              { name: 'travelQuotePremium', text: 'Travel Quote', route: true, hidden: true },
              { name: 'travelQuotePayment', text: 'Travel Quote', route: true, hidden: true },
              { name: 'packageQuote', text: 'Package Quote', route: true, hidden: true },
              { name: 'packageQuotePlans', text: 'Package Quote', route: true, hidden: true },
              { name: 'packageQuoteApplicant', text: 'Package Quote', route: true, hidden: true },
              { name: 'packageQuoteRisk', text: 'Package Quote', route: true, hidden: true },
              { name: 'packageQuotePremium', text: 'Package Quote', route: true, hidden: true },
              { name: 'packageQuotePayment', text: 'Package Quote', route: true, hidden: true },
              { name: 'paQuote', text: 'Personal Accident Quote', route: true, hidden: true }
            ]
          },
          {
            name: 'quoteListing',
            text: 'Listing',
            icon: 'mdi-format-list-bulleted-type',
            route: true,
            children: [
              {
                name: 'motorQuoteListing',
                text: 'Motor Listing',
                icon: appIcon.MOTOR,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'motorQuoteQuery', text: 'Motor Query', route: true, hidden: true }
                ]
              },
              {
                name: 'travelQuoteListing',
                text: 'Travel Listing',
                icon: appIcon.TRAVEL,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'travelQuoteQuery', text: 'Travel Query', route: true, hidden: true }
                ]
              },
              {
                name: 'fireQuoteListing',
                text: 'Fire Listing',
                icon: appIcon.FIRE,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'fireQuoteQuery', text: 'Fire Query', route: true, hidden: true }
                ]
              },
              {
                name: 'cargoQuoteListing',
                text: 'Cargo Listing',
                icon: appIcon.CARGO,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'cargoQuoteQuery', text: 'Cargo Query', route: true, hidden: true }
                ]
              },
              {
                name: 'maidQuoteListing',
                text: 'Maid Listing',
                icon: appIcon.MAID,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'maidQuoteQuery', text: 'Maid Query', route: true, hidden: true }
                ]
              },
              {
                name: 'packageQuoteListing',
                text: 'Package Listing',
                icon: appIcon.PACKAGE,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'packageQuoteQuery', text: 'Package Query', route: true, hidden: true }
                ]
              },
              {
                name: 'paQuoteListing',
                text: 'Personal Accident Listing',
                icon: appIcon.PA,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'paQuoteQuery', text: 'Personal Accident Query', route: true, hidden: true }
                ]
              }
            ]
          },
          {
            name: 'quotePosting',
            text: 'Posting',
            icon: 'mdi-file-send',
            route: true,
            children: [
              { name: 'motorQuotePosting', text: 'Motor Posting', icon: appIcon.MOTOR, hidden: true, searchable: true, route: true },
              { name: 'travelQuotePosting', text: 'Travel Posting', icon: appIcon.TRAVEL, hidden: true, searchable: true, route: true },
              { name: 'fireQuotePosting', text: 'Fire Posting', icon: appIcon.FIRE, hidden: true, searchable: true, route: true },
              { name: 'cargoQuotePosting', text: 'Cargo Posting', icon: appIcon.CARGO, hidden: true, searchable: true, route: true },
              { name: 'maidQuotePosting', text: 'Maid Posting', icon: appIcon.MAID, hidden: true, searchable: true, route: true },
              { name: 'packageQuotePosting', text: 'Package Posting', icon: appIcon.PACKAGE, hidden: true, searchable: true, route: true },
              { name: 'paQuotePosting', text: 'Personal Accident Posting', icon: appIcon.PA, hidden: true, searchable: true, route: true }
            ]
          },
          {
            name: 'quoteUpdateStatus',
            text: 'Update Status',
            icon: 'mdi-file-multiple',
            route: true,
            children: [
              { name: 'motorQuoteUpdateStatus', text: 'Motor Update Status', icon: appIcon.MOTOR, hidden: true, searchable: true, route: true },
              { name: 'travelQuoteUpdateStatus', text: 'Travel Update Status', icon: appIcon.TRAVEL, hidden: true, searchable: true, route: true },
              { name: 'fireQuoteUpdateStatus', text: 'Fire Update Status', icon: appIcon.FIRE, hidden: true, searchable: true, route: true },
              { name: 'cargoQuoteUpdateStatus', text: 'Cargo Update Status', icon: appIcon.CARGO, hidden: true, searchable: true, route: true },
              { name: 'maidQuoteUpdateStatus', text: 'Maid Update Status', icon: appIcon.MAID, hidden: true, searchable: true, route: true },
              { name: 'packageQuoteUpdateStatus', text: 'Package Update Status', icon: appIcon.PACKAGE, hidden: true, searchable: true, route: true },
              { name: 'paQuoteUpdateStatus', text: 'Personal Accident Update Status', icon: appIcon.PA, hidden: true, searchable: true, route: true }
            ]
          }
        ]
      },
      {
        name: 'claims',
        text: 'Claims',
        children: [
          {
            name: 'claimEntry',
            text: 'Enter Claim',
            icon: 'mdi-cash-usd',
            route: true,
            children: [
              { name: 'claimDetail', text: 'Claim Detail', route: true, hidden: true },
              { name: 'claimDetailItem', text: 'Claim Detail', route: true, hidden: true },
              { name: 'claimDetailReserve', text: 'Claim Detail', route: true, hidden: true },
              { name: 'claimDetailSummary', text: 'Claim Detail', route: true, hidden: true }
            ]
          },
          {
            name: 'claimStaging',
            text: 'Staging',
            icon: 'mdi-comment-text-multiple-outline',
            route: true,
            children: [
              {
                name: 'travelClaimStaging',
                text: 'Travel Claim Staging',
                icon: appIcon.TRAVEL,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'travelClaimStagingQuery', text: 'Staged Claim Query', route: true, hidden: true },
                  { name: 'travelClaimStagingReview', text: 'Staged Claim Review', route: true, hidden: true }
                ]
              },
              {
                name: 'fireClaimStaging',
                text: 'Fire Claim Staging',
                icon: appIcon.TRAVEL,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'fireClaimStagingQuery', text: 'Staged Claim Query', route: true, hidden: true },
                  { name: 'fireClaimStagingReview', text: 'Staged Claim Review', route: true, hidden: true }
                ]
              },
              {
                name: 'maidClaimStaging',
                text: 'Maid Claim Staging',
                icon: appIcon.TRAVEL,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'maidClaimStagingQuery', text: 'Staged Claim Query', route: true, hidden: true },
                  { name: 'maidClaimStagingReview', text: 'Staged Claim Review', route: true, hidden: true }
                ]
              }
            ]
          },
          {
            name: 'claimListing',
            text: 'Listing',
            icon: 'mdi-cash-multiple',
            route: true,
            children: [
              {
                name: 'motorClaimListing',
                text: 'Motor Claim Listing',
                icon: appIcon.MOTOR,
                route: true,
                hidden: true,
                searchable: true,
                children: [
                  { name: 'motorClaimQuery', text: 'Claim Query', route: true, hidden: true }
                ]
              },
              {
                name: 'travelClaimListing',
                text: 'Travel Claim Listing',
                icon: appIcon.TRAVEL,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'travelClaimQuery', text: 'Claim Query', route: true, hidden: true }
                ]
              },
              {
                name: 'fireClaimListing',
                text: 'Fire Claim Listing',
                icon: appIcon.FIRE,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'fireClaimQuery', text: 'Claim Query', route: true, hidden: true }
                ]
              },
              {
                name: 'maidClaimListing',
                text: 'Maid Claim Listing',
                icon: appIcon.MAID,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'maidClaimQuery', text: 'Claim Query', route: true, hidden: true }
                ]
              },
              {
                name: 'packageClaimListing',
                text: 'Package Claim Listing',
                icon: appIcon.PACKAGE,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'packageClaimQuery', text: 'Claim Query', route: true, hidden: true }
                ]
              },
              {
                name: 'cargoClaimListing',
                text: 'Cargo Claim Listing',
                icon: appIcon.CARGO,
                hidden: true,
                searchable: true,
                route: true,
                children: [
                  { name: 'cargoClaimQuery', text: 'Claim Query', route: true, hidden: true }
                ]
              }
            ]
          },
          {
            name: 'claimPosting',
            text: 'Posting',
            icon: 'mdi-file-send',
            route: true,
            children: [
              { name: 'motorClaimPosting', text: 'Motor Claim Posting', icon: appIcon.MOTOR, hidden: true, searchable: true, route: true },
              { name: 'travelClaimPosting', text: 'Travel Claim Posting', icon: appIcon.TRAVEL, hidden: true, searchable: true, route: true },
              { name: 'fireClaimPosting', text: 'Fire Claim Posting', icon: appIcon.FIRE, hidden: true, searchable: true, route: true },
              { name: 'maidClaimPosting', text: 'Maid Claim Posting', icon: appIcon.MAID, hidden: true, searchable: true, route: true },
              { name: 'cargoClaimPosting', text: 'Cargo Claim Posting', icon: appIcon.CARGO, hidden: true, searchable: true, route: true },
              { name: 'packageClaimPosting', text: 'Package Claim Posting', icon: appIcon.PACKAGE, hidden: true, searchable: true, route: true }
            ]
          },
          {
            name: 'claimUpdateStatus',
            text: 'Update Status',
            icon: 'mdi-file-multiple',
            route: true,
            children: [
              { name: 'motorClaimUpdateStatus', text: 'Motor Claim Update Status', icon: appIcon.MOTOR, hidden: true, searchable: true, route: true },
              { name: 'travelClaimUpdateStatus', text: 'Travel Claim Update Status', icon: appIcon.TRAVEL, hidden: true, searchable: true, route: true },
              { name: 'fireClaimUpdateStatus', text: 'Fire Claim Update Status', icon: appIcon.FIRE, hidden: true, searchable: true, route: true },
              { name: 'maidClaimUpdateStatus', text: 'Maid Claim Update Status', icon: appIcon.MAID, hidden: true, searchable: true, route: true },
              { name: 'cargoClaimUpdateStatus', text: 'Cargo Claim Update Status', icon: appIcon.CARGO, hidden: true, searchable: true, route: true },
              { name: 'packageClaimUpdateStatus', text: 'Package Claim Update Status', icon: appIcon.PACKAGE, hidden: true, searchable: true, route: true }
            ]
          }
        ]
      },
      {
        name: 'reports',
        text: 'Reports',
        children: [
          {
            name: 'agencyReports',
            text: 'Agency Reports',
            icon: 'mdi-file-chart',
            route: 'true',
            children: [
              {
                name: 'motorAgencyReports',
                text: 'Motor Reports',
                icon: appIcon.MOTOR,
                route: true,
                children: [
                  { name: 'motorSalesPerformance', text: 'Sales Performance', route: true, hidden: true, searchable: true },
                  { name: 'motorTransaction', text: 'Transaction', route: true, hidden: true, searchable: true },
                  { name: 'motorMthlyStats', text: 'Monthly Statistics', route: true, hidden: true, searchable: true },
                  { name: 'motorDeclineList', text: 'Decline Listing', route: true, hidden: true, searchable: true },
                  { name: 'motorExceptional', text: 'Exceptional', route: true, hidden: true, searchable: true },
                  { name: 'motorApprovedProposal', text: 'Approved Proposal', route: true, hidden: true, searchable: true },
                  { name: 'motorPrintQuote', text: 'Print Quotation', route: true, hidden: true, searchable: true },
                  { name: 'motorPrintCN', text: 'Print Cover Note', route: true, hidden: true, searchable: true }
                ]
              },
              {
                name: 'travelAgencyReports',
                text: 'Travel Reports',
                icon: appIcon.TRAVEL,
                route: true,
                children: [
                  { name: 'travelDailyTransaction', text: 'Daily Transaction', route: true, hidden: true, searchable: true },
                  { name: 'travelPerformance', text: 'Performance', route: true, hidden: true, searchable: true },
                  { name: 'travelReconciliation', text: 'Reconciliation', route: true, hidden: true, searchable: true },
                  { name: 'travelExceptional', text: 'Exceptional', route: true, hidden: true, searchable: true },
                  { name: 'travelPrintCertificate', text: 'Print Certificate', route: true, hidden: true, searchable: true },
                  { name: 'travelClientConsent', text: 'Client Consent', route: true, hidden: true, searchable: true },
                  { name: 'travelPieShare', text: 'Pie Share', route: true, hidden: true, searchable: true },
                  { name: 'travelTransactionInfo', text: 'Transaction Info', route: true, hidden: true, searchable: true },
                  { name: 'travelAnalytics', text: 'Analytics', route: true, hidden: true, searchable: true }
                ]
              },
              {
                name: 'fireAgencyReports',
                text: 'Fire Reports',
                icon: appIcon.FIRE,
                route: true,
                children: [
                  { name: 'firePrintCertificate', text: 'Print Fire Certificate', route: true, hidden: true, searchable: true },
                  { name: 'fireTransaction', text: 'Transaction', route: true, hidden: true, searchable: true },
                  { name: 'firePerformance', text: 'Performance', route: true, hidden: true, searchable: true },
                  { name: 'fireReconciliation', text: 'Reconciliation', route: true, hidden: true, searchable: true },
                  { name: 'fireExceptional', text: 'Exceptional', route: true, hidden: true, searchable: true },
                  { name: 'fireMthlyStats', text: 'Monthly Statistics', route: true, hidden: true, searchable: true }
                ]
              },
              {
                name: 'maidAgencyReports',
                text: 'Maid Reports',
                icon: appIcon.MAID,
                route: true,
                children: [
                  { name: 'maidPrintCertificate', text: 'Print Certificate', route: true, hidden: true, searchable: true },
                  { name: 'maidTransaction', text: 'Transaction', route: true, hidden: true, searchable: true },
                  { name: 'maidPerformance', text: 'Performance', route: true, hidden: true, searchable: true },
                  { name: 'maidReconciliation', text: 'Reconciliation', route: true, hidden: true, searchable: true },
                  { name: 'maidExceptional', text: 'Exceptional', route: true, hidden: true, searchable: true },
                  { name: 'maidMthlyStats', text: 'Monthly Statistics', route: true, hidden: true, searchable: true }
                ]
              },
              {
                name: 'cargoAgencyReports',
                text: 'Cargo Reports',
                icon: appIcon.CARGO,
                route: true,
                children: [
                  { name: 'cargoPrintCN', text: 'Print Cargo Cover Note', route: true, hidden: true, searchable: true },
                  { name: 'cargoTransaction', text: 'Transaction', route: true, hidden: true, searchable: true },
                  { name: 'cargoMthlyStats', text: 'Monthly Statistics', route: true, hidden: true, searchable: true }
                ]
              },
              {
                name: 'packageAgencyReports',
                text: 'Package Reports',
                icon: appIcon.PACKAGE,
                route: true,
                children: [
                  { name: 'packageTransaction', text: 'Transaction', route: true, hidden: true, searchable: true },
                  { name: 'packageExceptional', text: 'Exceptional', route: true, hidden: true, searchable: true },
                  { name: 'packageMthlyStats', text: 'Monthly Statistics', route: true, hidden: true, searchable: true },
                  { name: 'packageSummary', text: 'Summary', route: true, hidden: true, searchable: true },
                  { name: 'packagePrintCN', text: 'Print Cover Note', route: true, hidden: true, searchable: true }
                ]
              },
              {
                name: 'paAgencyReports',
                text: 'Personal Accident Reports',
                icon: appIcon.PA,
                route: true,
                children: [
                  { name: 'paPrintCertificate', text: 'Print Certificate', route: true, hidden: true, searchable: true },
                  { name: 'paDailyTransaction', text: 'Daily Transaction', route: true, hidden: true, searchable: true },
                  { name: 'paPerformance', text: 'Performance', route: true, hidden: true, searchable: true },
                  { name: 'paReconciliation', text: 'Reconciliation', route: true, hidden: true, searchable: true },
                  { name: 'paExceptional', text: 'Exceptional', route: true, hidden: true, searchable: true },
                  { name: 'paMthlyStats', text: 'Monthly Statistics', route: true, hidden: true, searchable: true }
                ]
              }
            ]
          },
          {
            name: 'claimsReports',
            text: 'Claims Reports',
            icon: 'mdi-file-chart',
            route: 'true',
            children: [
              { name: 'claimStatus', text: 'Claim Status', route: true, hidden: true, searchable: true },
              { name: 'claimTransaction', text: 'Claim Transaction', route: true, hidden: true, searchable: true },
              { name: 'claimSummary', text: 'Claim Summary', route: true, hidden: true, searchable: true }
            ]
          }
        ]
      },
      {
        name: 'parameters',
        text: 'Parameters',
        children: [
          {
            name: 'rateManagement',
            text: 'Rating',
            icon: 'mdi-calculator',
            children: [
              { name: 'benefit', text: 'Benefit', route: true },
              {
                name: 'busCls',
                text: 'Business Class',
                route: true,
                children: [
                  {
                    name: 'motorBusClsList',
                    text: 'Motor Listing',
                    route: true,
                    children: [
                      { name: 'motorBusClsGeneral', text: 'Review General', route: true },
                      { name: 'motorBusClsCover', text: 'Review Coverage', route: true },
                      { name: 'motorBusClsTariff', text: 'Review Tariff', route: true },
                      { name: 'motorNCD', text: 'No Claim Discount (NCD)', route: true },
                      { name: 'motorBusClsStats', text: 'Statistics', route: true },
                      { name: 'motorBusClsUom', text: 'Unit Of Measure', route: true },
                      { name: 'motorPermStatus', text: 'Permission', route: true },
                      { name: 'motorProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'motorBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'motorBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  },
                  {
                    name: 'travelBusClsList',
                    text: 'Travel Listing',
                    route: true,
                    children: [
                      { name: 'travelBusClsGeneral', text: 'Review General', route: true },
                      { name: 'travelProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'travelBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'travelBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  },
                  {
                    name: 'cargoBusClsList',
                    text: 'Cargo Listing',
                    route: true,
                    children: [
                      { name: 'cargoBusClsGeneral', text: 'Review General', route: true },
                      { name: 'cargoBusClsClause', text: 'Review Clause', route: true },
                      { name: 'cargoBusClsCover', text: 'Review Coverage', route: true },
                      { name: 'cargoBusClsTariff', text: 'Review Tariff', route: true },
                      { name: 'cargoBusClsStats', text: 'Statistics', route: true },
                      { name: 'cargoBusClsUom', text: 'Unit Of Measure', route: true },
                      { name: 'cargoProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'cargoBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'cargoBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  },
                  {
                    name: 'fireBusClsList',
                    text: 'Fire Listing',
                    route: true,
                    children: [
                      { name: 'fireBusClsGeneral', text: 'Review General', route: true },
                      { name: 'fireProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'fireBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'fireBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  },
                  {
                    name: 'maidBusClsList',
                    text: 'Maid Listing',
                    route: true,
                    children: [
                      { name: 'maidBusClsGeneral', text: 'Review General', route: true },
                      { name: 'maidProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'maidBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'maidBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  },
                  {
                    name: 'packageBusClsList',
                    text: 'Package Listing',
                    route: true,
                    children: [
                      { name: 'packageBusClsGeneral', text: 'Review General', route: true },
                      { name: 'packageProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'packageBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'packageBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  },
                  {
                    name: 'paBusClsList',
                    text: 'Personal Accident Listing',
                    route: true,
                    children: [
                      { name: 'paBusClsGeneral', text: 'Review General', route: true },
                      { name: 'paProdBusCls', text: 'Product Business Class', route: true },
                      { name: 'paBusClsClmNol1', text: 'Business Class Nature of Loss', route: true },
                      { name: 'paBusClsClmResCat', text: 'Business Class Reserve Category', route: true }
                    ]
                  }
                ]
              },
              { name: 'coverage', text: 'Coverage', route: true },
              {
                name: 'product',
                text: 'Product',
                icon: 'mdi-cube-outline',
                route: true,
                children: [
                  {
                    name: 'motorProductList',
                    text: 'Motor Product List',
                    route: true,
                    children: [
                      { name: 'motorProductReview', text: 'Review Product', route: true },
                      { name: 'motorProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'motorProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'motorStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  },
                  {
                    name: 'travelProductList',
                    text: 'Travel Product List',
                    route: true,
                    children: [
                      { name: 'travelProductReview', text: 'Review Product', route: true },
                      { name: 'travelProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'travelProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'travelProductSchemeReview', text: 'Review Product Scheme', route: true },
                      { name: 'travelProductDiscLdgReview', text: 'Review Product Discount Loading', route: true },
                      { name: 'travelProductISOCountryReview', text: 'Review Product ISO Country', route: true },
                      { name: 'travelStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  },
                  {
                    name: 'fireProductList',
                    text: 'Fire Product List',
                    route: true,
                    children: [
                      { name: 'fireProductReview', text: 'Review Product', route: true },
                      { name: 'fireProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'fireProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'fireProductSchemeReview', text: 'Review Product Scheme', route: true },
                      { name: 'fireProductConstrnClsReview', text: 'Review Product Construction Class', route: true },
                      { name: 'fireStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  },
                  {
                    name: 'cargoProductList',
                    text: 'Cargo Product List',
                    route: true,
                    children: [
                      { name: 'cargoProductReview', text: 'Review Product', route: true },
                      { name: 'cargoProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'cargoProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'cargoStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  },
                  {
                    name: 'maidProductList',
                    text: 'Maid Product List',
                    route: true,
                    children: [
                      { name: 'maidProductReview', text: 'Review Product', route: true },
                      { name: 'maidProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'maidProductSchemeReview', text: 'Review Product Scheme', route: true },
                      { name: 'maidProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'maidStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  },
                  {
                    name: 'packageProductList',
                    text: 'Package Product List',
                    route: true,
                    children: [
                      { name: 'packageProductReview', text: 'Review Product', route: true },
                      { name: 'packageProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'packageProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'packageProductSchemeReview', text: 'Review Product Scheme', route: true },
                      { name: 'packageStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  },
                  {
                    name: 'paProductList',
                    text: 'Personal Accident Product List',
                    route: true,
                    children: [
                      { name: 'paProductReview', text: 'Review Product', route: true },
                      { name: 'paProductBusClsReview', text: 'Review Product Business Class', route: true },
                      { name: 'paProductCampaignReview', text: 'Review Product Campaign', route: true },
                      { name: 'paProductSchemeReview', text: 'Review Product Scheme', route: true },
                      { name: 'paProductDiscLdgReview', text: 'Review Product Discount Loading', route: true },
                      { name: 'paProductISOCountryReview', text: 'Review Product ISO Country', route: true },
                      { name: 'paStdCommDiscFactors', text: 'Review Standard Comm/Disc Factors', route: true }
                    ]
                  }
                ]
              },
              {
                name: 'schemesList',
                text: 'Schemes',
                route: true,
                children: [
                  { name: 'schemeReview', text: 'Scheme Review', route: true },
                  { name: 'schemeDurationList', text: 'Scheme Duration', route: true },
                  { name: 'pkgMenu', text: 'Package', route: true },
                  { name: 'pkgTariff', text: 'Tariff', route: true },
                  { name: 'pkgStdText', text: 'Standard Text', route: true },
                  { name: 'pkgOptCvr', text: 'Optional Coverage', route: true },
                  { name: 'familyPlan', text: 'Family Plan', route: true }
                ]
              },
              {
                name: 'statistics',
                text: 'Statistics',
                route: true,
                children: [
                  { name: 'statsQuery', text: 'Query Statistics', route: true },
                  { name: 'statsReview', text: 'Review Statistics', route: true }
                ]
              },
              { name: 'tariff', text: 'Tariff', route: true },
              { name: 'uom', text: 'Unit Of Measure', route: true },
              { name: 'modules', text: 'General Module Setting', route: true }
            ]
          },
          {
            name: 'textManagement',
            text: 'Text',
            icon: 'mdi-format-text',
            children: [
              {
                name: 'stdRiskText',
                text: 'Standard Risk Text',
                route: true,
                children: [
                  { name: 'stdRiskTextReview', text: 'Review Standard Risk Text', route: true }
                ]
              }
            ]
          },
          {
            name: 'vehManagement',
            text: 'Vehicle',
            icon: appIcon.MOTOR,
            children: [
              { name: 'vehBodyTypes', text: 'Body Types', route: true },
              { name: 'vehGrps', text: 'Group', route: true },
              { name: 'vehMakes', text: 'Makes', route: true },
              { name: 'vehModels', text: 'Models', route: true },
              { name: 'vehUsgs', text: 'Usages', route: true }
            ]
          },
          {
            name: 'vesManagement',
            text: 'Vessel',
            icon: appIcon.CARGO,
            children: [
              { name: 'vslCls', text: 'Class', route: true },
              { name: 'vslConstn', text: 'Construction', route: true },
              { name: 'vesEngMake', text: 'Engine Make', route: true },
              { name: 'vesEngModel', text: 'Engine Model', route: true },
              { name: 'vslFlag', text: 'Flag', route: true },
              { name: 'vslType', text: 'Type', route: true },
              { name: 'vslDetVoy', text: 'Details & Voyage', route: true }
            ]
          },
          {
            name: 'miscManagement',
            text: 'Miscellaneous',
            children: [
              { name: 'miscISOCty', text: 'ISO Country', icon: 'mdi-flag', route: true },
              { name: 'miscDuration', text: 'Duration', icon: 'mdi-clock', route: true },
              { name: 'SGAddress', text: 'Address', route: true }
            ]
          },
          {
            name: 'fireManagement',
            text: 'Fire',
            icon: appIcon.FIRE,
            children: [
              { name: 'fireConstrnCls', text: 'Construction Class', route: true },
              { name: 'fireOccupancy', text: 'Occupancy', route: true }
            ]
          },
          {
            name: 'currManagement',
            text: 'Currency',
            icon: appIcon.CURR,
            children: [
              { name: 'currList', text: 'Currency List', route: true }
            ]
          },
          {
            name: 'promotionManagement',
            text: 'Promotion',
            icon: 'mdi-star-circle',
            children: [
              {
                name: 'campaigns',
                text: 'Campaigns',
                icon: 'mdi-calendar-multiple',
                route: true,
                children: [
                  { name: 'campaignQuery', text: 'Query Campaign', route: true },
                  { name: 'campaignPromotionQuery', text: 'Query Promotions', route: true },
                  { name: 'intermediaryCampaignQuery', text: 'Query Intermediaries', route: true },
                  { name: 'productCampaignQuery', text: 'Query Products', route: true },
                  { name: 'campaignReview', text: 'Review Campaign', route: true },
                  { name: 'campaignPromotionReview', text: 'Review Promotions', route: true },
                  { name: 'intermediaryCampaignReview', text: 'Review Intermediaries', route: true },
                  { name: 'productCampaignReview', text: 'Review Products', route: true }
                ]
              },
              {
                name: 'promotions',
                text: 'Promotions',
                icon: 'mdi-ticket',
                route: true,
                children: [
                  { name: 'promotionQuery', text: 'Query Promotion', route: true },
                  { name: 'promotionReview', text: 'Review Promotion', route: true },
                  { name: 'promotionFactorQuery', text: 'Query Factor/Rates', route: true },
                  { name: 'promotionFactorReview', text: 'Review Factor/Rates', route: true },
                  { name: 'promotionCreditCardQuery', text: 'Query Promotion Credit Card List', route: true },
                  { name: 'promotionCreditCardReview', text: 'Review Promotion Credit Card List', route: true },
                  { name: 'promotionCouponQuery', text: 'Query Promotion Coupon', route: true },
                  { name: 'promotionCouponReview', text: 'Review Promotion Coupon', route: true },
                  { name: 'promotionMemberGroupQuery', text: 'Query Promotion Member Group', route: true },
                  { name: 'promotionMemberGroupReview', text: 'Review Promotion Member Group', route: true }
                ]
              },
              {
                name: 'creditCardLists',
                text: 'Credit Card Lists',
                icon: 'mdi-credit-card-multiple',
                route: true,
                children: [
                  { name: 'creditCardListQuery', text: 'Query Credit Card List', route: true },
                  { name: 'creditCardListReview', text: 'Review Credit Card List', route: true }
                ]
              },
              {
                name: 'loyalties',
                text: 'Loyalties',
                icon: 'mdi-wallet-membership',
                route: true,
                children: [
                  { name: 'loyaltyQuery', text: 'Query Loyalty', route: true },
                  { name: 'loyaltyReview', text: 'Review Loyalty', route: true }
                ]
              }
            ]
          },
          {
            name: 'crgoManagement',
            text: 'Cargo',
            icon: appIcon.CARGO,
            children: [
              { name: 'crgoComdty', text: 'Commodity', route: true },
              { name: 'crgoConvy', text: 'Conveyance', route: true },
              { name: 'crgoPack', text: 'Packaging', route: true },
              { name: 'crgoPort', text: 'Port', route: true },
              { name: 'crgoVoyage', text: 'Voyage', route: true },
              { name: 'crgoVoyDate', text: 'Voyage Date', route: true },
              { name: 'crgoClse', text: 'Clause', route: true }
            ]
          },
          {
            name: 'travelManagement',
            text: 'Travel',
            icon: appIcon.TRAVEL,
            children: [
              { name: 'travelArea', text: 'Area', route: true },
              { name: 'discLdg', text: 'Discount/Loading', route: true }
            ]
          },
          {
            name: 'paManagement',
            text: 'Personal Accident',
            icon: appIcon.PA,
            children: [
              { name: 'paOccpCls', text: 'Occupation Class', route: true },
              { name: 'paRelationship', text: 'Relationship', route: true }
            ]
          },
          {
            name: 'claimManagement',
            text: 'Claim',
            icon: 'mdi-cash-usd',
            children: [
              { name: 'clmType', text: 'Claim Types', route: true },
              { name: 'clmSubType', text: 'Claim Sub Types', route: true },
              { name: 'clmTypeDet', text: 'Claim Type Details', route: true },
              { name: 'clmTypeAttach', text: 'Claim Type Attachments', route: true },
              { name: 'clmNol', text: 'Nature of Loss', route: true },
              { name: 'clmResCat', text: 'Reserve Category', route: true }
            ]
          }
        ]
      },
      {
        name: 'settings',
        text: 'Settings',
        children: [
          {
            name: 'userManagement',
            text: 'User Management',
            icon: 'mdi-folder-account',
            children: [
              {
                name: 'users',
                text: 'Users',
                icon: 'mdi-account-group',
                route: true,
                children: [
                  { name: 'userQuery', text: 'Query User', hidden: true },
                  { name: 'userReview', text: 'Review User', hidden: true }
                ]
              },
              { name: 'usersSessions', text: 'Sessions', icon: 'mdi-account-network', route: true },
              { name: 'roles', text: 'Roles', icon: 'mdi-account-key', route: true },
              {
                name: 'userSecurity',
                text: 'User Security',
                icon: 'mdi-security-account',
                children: [
                  { name: 'userBlock', text: 'Unblock User / IP Address', icon: 'mdi-account-off', route: true },
                  { name: 'whiteList', text: 'Whitelist IP Address', icon: 'mdi-verified', route: true },
                  { name: 'userPassSettings', text: 'User Password Settings', icon: 'mdi-textbox-password', route: true },
                  { name: 'acctSecuritySettings', text: 'Account Security Settings', icon: 'mdi-account-settings-variant', route: true },
                  {
                    name: 'privileges',
                    text: 'Privileges',
                    icon: 'mdi-account-key',
                    route: true,
                    children: [
                      { name: 'privilegesReview', text: 'Review Privilege Group', route: true }
                    ]
                  },
                  { name: 'passwordBlacklist', text: 'Password Blacklist', icon: 'mdi-verified', route: true }
                ]
              }
            ]
          },
          {
            name: 'memberManagement',
            text: 'Member Managment',
            icon: 'mdi-folder-account',
            children: [
              {
                name: 'membersList',
                text: 'Member List',
                icon: 'mdi-account-card-details',
                route: true,
                children: [
                  { name: 'memberDet', text: 'Member Details', hidden: true },
                  { name: 'memberQuery', text: 'Query Member', hidden: true }
                ]
              },
              {
                name: 'memberGroups',
                text: 'Member Groups',
                icon: 'mdi-account-card-details',
                route: true,
                children: [
                  { name: 'memberGroupQuery', text: 'Query Member Group', route: true },
                  { name: 'memberGroupReview', text: 'Review Member Group', route: true }
                ]
              },
              { name: 'insuredBlacklist', text: 'Insured Blacklist', icon: 'mdi-account-off', route: true }
            ]
          },
          {
            name: 'interManagement',
            text: 'Intermediary Management',
            icon: 'mdi-folder-account',
            children: [
              {
                name: 'intermediaries',
                text: 'Intermediaries',
                icon: 'mdi-account-group',
                route: true,
                children: [
                  { name: 'queryProfile', text: 'Query Profile', hidden: true },
                  { name: 'queryUsers', text: 'Query Users', hidden: true },
                  { name: 'queryProducts', text: 'Query Products', hidden: true },
                  { name: 'reviewProfile', text: 'Review Pofile', hidden: true },
                  { name: 'reviewUsers', text: 'Review Users', hidden: true },
                  { name: 'reviewProducts', text: 'Review Products', hidden: true }
                ]
              }
            ]
          },
          {
            name: 'b2cManagement',
            text: 'B2C Management',
            children: [
              {
                name: 'b2cKeys',
                text: 'B2C Keys',
                route: true
              },
              {
                name: 'referrers',
                text: 'Referrers',
                route: true
              }
            ]
          },
          { name: 'cacheControl', text: 'Cache Control', icon: 'mdi-content-save-settings', route: true }
        ]
      },
      { name: 'rptJobs', text: 'Report History', route: true, hidden: true },
      {
        name: 'user',
        text: 'User Settings',
        route: true,
        hidden: true,
        children: [
          { name: 'profile', text: 'User Profile', route: true },
          { name: 'changePassword', text: 'Change Password', route: true },
          { name: 'notificationSettings', text: 'Notification Settings', route: true }
        ]
      }
    ]
  }
]
